import { useContext } from "react"
import { AppText, CustomContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import { AppCenterPopupD2, CenterPopupHeaderD2, SidePopupLayout } from "src/component"
import { FaRegMoneyBillAlt } from "react-icons/fa"
import { moneyFormat } from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { Design } from "src/model"

export const RepaymentSchedule: React.FC<any> = ({close, repaymentSchedule, details}:{close: ()=>void, repaymentSchedule: RepaymentScheduleType[], details:LoanDetail}) => {
    const {info: {institutionData}} = useContext(AppInfoContext)

    const Container =({children}:{children: React.ReactNode}) => {
        switch(true){
            case institutionData.design === Design.DESIGN_2:
                return  (
                    <AppCenterPopupD2  zIndex='6' overflow='hidden' close={close}>
                        <CenterPopupHeaderD2 title='Loan Repayment Schedule' close={close} />
                        {children}
                    </AppCenterPopupD2>)
            default:
                return( 
                    <SidePopupLayout close={close}>
                        <ScreenTitle textSize="2.2" fontWeight="700">Loan Repayment Schedule</ScreenTitle>
                        {children}
                    </SidePopupLayout>)
        }
    }
    return (
        <Container>
            <CustomContainer topMargin="2.5">
                <GridContainer
                    bgColor="#E7F6F5" minHeight="6.2" padding="1"
                    leftPadding="2" rightPadding="2" radius="0.8" 
                >
                    <FlexRow>
                        <FaRegMoneyBillAlt style={{color: '#0D968F', fontSize: '2rem'}} />
                        <AppText textSize="1.2" color="#0A756F" leftMargin="1">
                            Total Repayment Amount: {moneyFormat(details.totalRepaymentAmount, true,institutionData?.defaultCurrency)}
                        </AppText>
                    </FlexRow>
                </GridContainer>
                <CustomContainer topMargin="2">
                    <FlexRow 
                        gap="2" justifyContent="space-between" padding="1"
                        leftPadding="2" rightPadding="2" minHeight="4.5"
                        bgColor="#F9FAFB"
                        hasBottomBorder
                        borderBottomColor="#EAECF0"
                    >
                        <AppText color="#0A756F" fontWeight="600" fontFamily="Gilmer-Bold">Due Date</AppText>
                        <AppText color="#0A756F" fontWeight="600" fontFamily="Gilmer-Bold">Amount</AppText>
                        <AppText color="#0A756F" fontWeight="600" fontFamily="Gilmer-Bold">Status</AppText>
                    </FlexRow>
                    {
                        repaymentSchedule?.map((item, index) => {
                            return (
                                <GridContainer 
                                    minHeight="7.2" key={index} padding='1'
                                    leftPadding="2" rightPadding="2"
                                    style={{borderBottom: '1px solid #EAECF0'}}
                                >
                                    <FlexRow gap="2" justifyContent="space-between">
                                        <AppText fontWeight="600" color="#101828">{item.paymentDueDate}</AppText>
                                        <AppText color="#667085">&#8358;{item.total}</AppText>
                                        <AppText color="#667085">{!!item?.isPrincipalApplied ? 'Paid' : 'Pending'}</AppText>
                                    </FlexRow>
                                </GridContainer>
                            )
                        })
                    }
                </CustomContainer>
            </CustomContainer>
        </Container>
    )
}

type RepaymentScheduleType = {
    accountNumber:number
    fee: string
    id: number
    interest: string
    isFeeApplied: boolean
    isInterestApplied: boolean 
    isPrincipalApplied:boolean
    paymentDueDate:string
    principal:number
    total: number
}

type LoanDetail = {
    number: number
    product: string
    loanAmount: number
    loanCycle: number
    interestRate: number
    monthlyInterestRate: number
    amountLeft: number
    nextPaymentDate: string
    maturityDate: string
    totalRepaymentAmount: number
    realLoanStatus: string
}